import React, { useEffect } from "react";
import { Form, Modal, DatePicker } from "antd";
import dayjs from "dayjs";
import "./TargetAchievementsModal.scss";

// 🟢 Reusable components
import InputField from "../../../Reuseable/InputField/InputField";
import CustomSelect from "../../../Reuseable/Select/Select";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";

const { RangePicker } = DatePicker;

const TargetAchievementsModal = ({
  isOpen,
  onClose,
  userData = {},
  onSave,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (userData) {
      const { startDate, endDate, ...rest } = userData;
      form.setFieldsValue({
        ...rest,
        duration:
          startDate && endDate ? [dayjs(startDate), dayjs(endDate)] : undefined,
      });
    } else {
      form.resetFields();
    }
  }, [userData, form]);

  const handleSave = () => {
    form.validateFields().then((values) => {
      const [startDate, endDate] = values.duration || [];
      const payload = {
        ...values,
        startDate: startDate?.format("YYYY-MM-DD"),
        endDate: endDate?.format("YYYY-MM-DD"),
      };
      delete payload.duration;
      onSave?.(payload);
      onClose();
    });
  };

  const targetOptions = [
    { label: "Target login hours", value: "login_hours" },
    { label: "Resolved cases", value: "resolved_cases" },
    { label: "New connections", value: "new_connections" },
  ];

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      title="Edit Target"
      className="targetAchievementModalContainer"
      centered
    >
      <div className="targetModalWrapper">
        <Form layout="vertical" form={form}>
          {/* Duration */}
          <Form.Item
            label="Duration"
            name="duration"
            className="formItem"
            rules={[{ message: "Please select a date range" }]}
          >
            <RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />
          </Form.Item>

          {/* User field - read only */}
          <Form.Item
            name="user"
            className="formItem"
            rules={[{ required: true, message: "Please enter user name" }]}
          >
            <InputField label="Users" placeholder="Guy Hawkins" readOnly />
          </Form.Item>

          {/* Target select field */}
          <Form.Item
            name="target"
            className="formItem"
            rules={[{ required: true, message: "Please select a target" }]}
          >
            <CustomSelect
              label="Select Target"
              placeholder="Target login hours"
              options={targetOptions}
            />
          </Form.Item>

          {/* Target Value */}
          <Form.Item
            name="targetValue"
            className="formItem"
            rules={[{ required: true, message: "Please enter a value" }]}
          >
            <InputField
              label="Target Value"
              placeholder="Enter target value"
              type="number"
            />
          </Form.Item>

          {/* Submit button */}
          <div className="submitBtn">
            <NormalButton type="primary" onClick={handleSave}>
              Submit
            </NormalButton>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default TargetAchievementsModal;
